import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {WebServer} from './WebServer';
import {ToastController} from '@ionic/angular';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class APIClient {


  constructor(  public http: HttpClient , public toastController: ToastController, public  webServer: WebServer) { }

  /*Get Data*/
  get(urlWithQueryParams: string,token) {
    const httpHeaders = new HttpHeaders().set('access-token', token);
    httpHeaders.set('Content-Type', 'application/json');


   /*   httpHeaders.set('Content-Type', 'application/json');
      httpHeaders.set('Accept', 'application/json');

      httpHeaders.set('Access-Control-Allow-Origin', 'http://192.168.1.18:8001');*/

    const options = {
      headers: httpHeaders,
      observe: 'response' as 'body',
    };
    return this.http.get<any>(urlWithQueryParams, options)
    .pipe(map(response => {
          return response;
        }, error => {
        // this.authService.hideLoader();
        console.log(error);
    }));
  }

  /*Post Data*/
    post(url: string, postData: any,token='') {

      const httpHeaders = new HttpHeaders().set('access-token', token);
      httpHeaders.append('Content-Type', 'application/json');
      httpHeaders.append('Access-Control-Allow-Origin', 'http://127.0.0.1:8100');

      /* httpHeaders.set('Content-Type', 'application/json');
        httpHeaders.set('Accept', 'application/json');

        httpHeaders.set('Access-Control-Allow-Origin', 'http://192.168.1.18:8001');*/
        // httpHeaders = new HttpHeaders().set('Authorization', localStorage.getItem('Auth'));
        const options = {
            headers: httpHeaders,
            observe: 'response' as 'body',
        };

        return this.http.post<any>(url, postData, options);
    }



 /*put Data*/
 put(url: string, postData: any,token='') {

  const httpHeaders = new HttpHeaders().set('access-token', token);
  httpHeaders.set('Content-Type', 'application/json');
  /* httpHeaders.set('Content-Type', 'application/json');
    httpHeaders.set('Accept', 'application/json');

    httpHeaders.set('Access-Control-Allow-Origin', 'http://192.168.1.18:8001');*/
    // httpHeaders = new HttpHeaders().set('Authorization', localStorage.getItem('Auth'));
    const options = {
        headers: httpHeaders,
        observe: 'response' as 'body',
    };

    return this.http.put<any>(url, postData, options);
}



}
